import React, { Component } from 'react';
import { Route, Switch , HashRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import Login from './pages/login';
import Home from './pages/home';
import {
    ImpressaoRelatorioRetrospectiva as impressaoRelatorioRetrospectiva
} from "./components/impressaoRelatorioRetrospectiva";
import {GuardaForaDoLayout} from "./components/acesso";
import PortalCliente from "./pages/portalCliente";

// Fora do Home, entao sem a guarda do content: usa a propria (#484909).
const ImpressaoRetrospectiva = (props: any) => (
    <GuardaForaDoLayout pagina="/impressao-retrospectiva">
        {React.createElement(impressaoRelatorioRetrospectiva, props)}
    </GuardaForaDoLayout>
);

class Routes extends Component  {
    render () {
        return (
            <HashRouter>
                <Switch>
                    <Route component={ImpressaoRetrospectiva} path="/impressao-retrospectiva"/>
                    {/* Portal do cliente (#480058): aberto pela plataforma do cliente so com a sessao, sem login do admin */}
                    <Route component={PortalCliente} path="/portal" exact/>
                    <Route component={Login} path="/login" exact/>
                    <Route component={Home} path="/"/>
                </Switch>
            </HashRouter>
        )
    }
}

export default connect()(Routes);